<template>
  <div>
    <!-- 批量修改渠道包名 -->
    <el-dialog title="批量修改渠道包名" :visible.sync="dialogNameVisible" width="90%" append-to-body top="1vh">
      <el-form :inline="true" v-model="nameSearchValue" class="demo-form-inline">
        <el-form-item label="渠道包ID:">
          <el-input v-model="nameSearchValue.id" placeholder="请输入渠道包ID"></el-input>
        </el-form-item>
        <el-form-item label="渠道包名称:">
          <el-input v-model="nameSearchValue.name" placeholder="请输入渠道包名称"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏包:">
          <el-select v-model="nameSearchValue.game_package_id" filterable clearable placeholder="请选择"
            @change="selectChannel">
            <el-option v-for="item in gamePackageList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道:">
          <el-select v-model="nameSearchValue.channel_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in channelSelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司主体:">
          <el-select v-model="nameSearchValue.company_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in companySelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getNameChannelPackageList">搜索</el-button>
        </el-form-item>
        <br />
        <el-form-item label="批量修改渠道包名(名字最多20个中英文字符)[用换行分割]:">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="nameText" style="width:400px;">
          </el-input>
          <el-button style="margin-left: 10px;" type="success" @click="setNameChange">填入</el-button>
        </el-form-item>
      </el-form>
      <el-table stripe v-loading="loadingData" ref="tableNameData" :data="namePackageList" :max-height="450" border
        style="width: 100%" @selection-change="handleNameSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" width="80"> </el-table-column>
        <el-table-column prop="name" label="渠道包名称"> </el-table-column>
        <el-table-column prop="packages.name" label="所属游戏包">
        </el-table-column>
        <el-table-column prop="channels.name" label="所属渠道"> </el-table-column>
      </el-table>
      <div v-if="currentNameSelection.length">
        <p>批量修改：</p>
        <el-table :data="currentNameSelection" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80"> </el-table-column>
          <el-table-column prop="name" label="渠道包名称"> </el-table-column>
          <el-table-column label="新包名">
            <template slot-scope="scope">
              <el-input v-model="scope.row.new_name" placeholder="请输入修改的包名"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="currentNameSelection = currentNameSelection.filter(({ id }) => id !== scope.row.id)"
                type="danger" icon="el-icon-delete" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setNamePackageSelect">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="渠道包ID:">
          <el-input v-model="searchValue.id" placeholder="请输入渠道包ID"></el-input>
        </el-form-item>
        <el-form-item label="渠道包名称:">
          <el-input v-model="searchValue.name" placeholder="请输入渠道包名称"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏包:">
          <el-select v-model="searchValue.game_package_id" filterable clearable placeholder="请选择"
            @change="selectChannel">
            <el-option v-for="item in gamePackageList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道:">
          <el-select v-model="searchValue.channel_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in channelSelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司主体:">
          <el-select v-model="searchValue.company_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in companySelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" @click="searchChannelPackageList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportChannelPackage()">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="dialogNameVisible = true">批量修改渠道包名</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            :loading="batchVerifyVersionLoading"
            @click="openBatchVerifyVersionPrompt"
          >
            批量修改提审版本号<span v-if="selectedVerifyVersionPackages.length">
              ({{ selectedVerifyVersionPackages.length }})</span
            >
          </el-button>
        </el-form-item>
      </el-form>
      <el-button type="success" plain @click="channelPackageAddDialog">渠道包新增</el-button>
    </div>
    <!-- <div slot="header">
      <el-row type="flex" justify="space-between">
        <el-col :span="12">
          <el-button
            type="primary"
            plain
            style="margin-bottom: 10px"
            @click="batchPack()"
            >批量打包</el-button
          >
        </el-col>
      </el-row>
    </div> -->
    <el-table stripe v-loading="loadingData" ref="tableData" :data="tableData" row-key="id"
      :max-height="tableHeight" border style="width: 100%"
      @selection-change="handleVerifyVersionSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" reserve-selection> </el-table-column>
      <el-table-column prop="id" label="ID" width="80"> </el-table-column>
      <el-table-column prop="created_at" label="创建日期"> </el-table-column>
      <el-table-column prop="name" label="渠道包名称"> </el-table-column>
      <el-table-column prop="packages.name" label="所属游戏包">
      </el-table-column>
      <el-table-column prop="channels.name" label="所属渠道"> </el-table-column>
      <el-table-column prop="company.name" label="公司主体"> </el-table-column>
      <el-table-column prop="pack_status" label="分包状态"> </el-table-column>
      <el-table-column prop="packed_at" label="分包日期"> </el-table-column>
      <el-table-column prop="version" label="当前版本号"> </el-table-column>
      <el-table-column label="媒体配置">
        <template slot-scope="scope">
          {{ scope.row.media_setting == null ? "未配置" : "已配置" }}
        </template>
      </el-table-column>
      <el-table-column label="渠道配置">
        <template slot-scope="scope">
          {{ scope.row.union_setting == null ? "未配置" : "已配置" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <el-button type="warning" plain @click="channelPackageEditDialog(scope.row)" title="">编辑</el-button>
          <el-button type="success" plain @click="packaging(scope.row.id)"
            v-if="scope.row.packages && scope.row.packages.os != 1" title="">打包</el-button>
          <el-button type="danger" plain @click="downloadFile(scope.row.download_url)" title="">下载</el-button>
          <el-button type="primary" plain style="margin-left: 0; margin-top: 10px"
            @click="handleCopy(scope.$index, scope.row)" :disabled="scope.row.pack_status !== '分包成功'">复制下载链接</el-button>
          <el-button v-if="scope.row.http_header" type="success" plain style="margin-left: 0; margin-top: 10px"
            @click="handleCopy(scope.$index, scope.row, 'action_track_url')">复制监测链接</el-button>
          <!-- <el-button
            v-if="scope.row.http_header"
            type="success"
            plain
            style="margin-left: 0; margin-top: 10px"
            @click="handleCopy(scope.$index, scope.row, 'star_track_url')"
            >复制星图链接</el-button
          > -->
          <el-button type="warning" plain @click="channelPackageCooperateDialog(scope.row)" title="">商务合作</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords">
      </el-pagination>
    </div>

    <!-- 新增渠道包对话框 -->
    <el-dialog
      title="新增渠道包"
      :visible.sync="addDialogFormVisible"
      :close-on-click-modal="false"
      append-to-body
      width="40%"
      top="5vh"
      custom-class="channel-package-dialog"
      @open="resetChannelPackageDialogScroll('addDialogBody')"
    >
      <div ref="addDialogBody" class="channel-package-dialog__body">
      <el-form :model="addform" :rules="addRules" label-width="100px" ref="addform">
        <el-form-item label="渠道包名称" prop="name">
          <el-input type="textarea" placeholder="支持换行批量" v-model="addform.name"></el-input>
        </el-form-item>
        <el-form-item label="媒体配置" prop="media_setting">
          <el-input v-model="addform.media_setting"></el-input>
        </el-form-item>
        <el-form-item label="渠道配置">
          <el-input v-model="addform.union_setting"></el-input>
        </el-form-item>
        <el-form-item label="提审版本号">
          <el-input v-model="addform.verify_version"></el-input>
        </el-form-item>
        <el-form-item label="是否显示公告">
          <el-radio-group v-model="addform.is_notice">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="登录实名">
          <el-radio-group v-model="addform.is_login_cert">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否真实实名">
          <el-radio-group v-model="addform.is_real_cert">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否强制实名">
          <el-radio-group v-model="addform.is_force_cert">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否强制更新">
          <el-radio-group v-model="addform.is_force_update">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否正版iOS">
          <el-radio-group v-model="addform.genuine_ios">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="调试模式">
          <el-radio-group v-model="addform.is_debug">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属游戏包" prop="game_package_id">
          <el-select v-model="addform.game_package_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in gamePackageList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道" prop="channel_id">
          <el-select v-model="addform.channel_id" filterable clearable placeholder="请选择" :disabled="isMultipleName">
            <el-option v-for="item in channelSelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <p v-show="isMultipleName" style="color: red;font-size: 12px;">批量创建会按名称自动匹配已创建的同名渠道进行关联</p>
        </el-form-item>
        <el-form-item label="公司主体" prop="company_id">
          <el-select v-model="addform.company_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in companySelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <template v-if="addform.company_id === 7">
            <p style="color: red; margin-bottom: 0;"> * 注意：当前切的是三足乌的主体，会影响支付！！</p>
            <p style="color: red; margin: 0;">（2026-02-28 17点之前的包切支付，三足乌微信支付无法使用）</p>
          </template>
          <template v-else-if="addform.company_id === 8">
            <p style="color: red; margin-bottom: 0;"> * 注意：当前切的是三足乌-趣智联的主体，会影响支付！！</p>
            <p style="color: red; margin: 0;">（2026-06-29 12点之前的包切支付，三足乌-趣智联微信和支付宝支付无法使用）</p>
          </template>
        </el-form-item>
        <el-form-item label="隐私政策" prop="privacy">
          <wEditor ref="editorPrivacy" />
        </el-form-item>
        <el-form-item label="用户协议" prop="protocol">
          <wEditor ref="editorProtocol" />
        </el-form-item>
      </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addChannelPackageSubmit('addform')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑渠道对话框 -->
    <el-dialog
      title="编辑渠道包"
      :visible.sync="editDialogFormVisible"
      :close-on-click-modal="false"
      append-to-body
      width="45%"
      top="5vh"
      custom-class="channel-package-dialog"
      @open="resetChannelPackageDialogScroll('editDialogBody')"
    >
      <div ref="editDialogBody" class="channel-package-dialog__body">
      <el-form :model="editform" :rules="rules" label-width="156px" ref="editform">
        <el-form-item label="渠道包名称:">
          <el-input v-model="editform.name"></el-input>
        </el-form-item>
        <el-form-item label="媒体配置:" prop="media_setting">
          <el-input v-model="editform.media_setting"></el-input>
        </el-form-item>
        <el-form-item label="渠道配置:">
          <el-input v-model="editform.union_setting"></el-input>
        </el-form-item>
        <el-form-item label="提审版本号:">
          <el-input v-model="editform.verify_version"></el-input>
        </el-form-item>
        <el-form-item label="当前版本号:">
          <el-input v-model="version" disabled></el-input>
        </el-form-item>
        <el-form-item label="是否显示公告:">
          <el-radio-group v-model="editform.is_notice">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="登录实名:">
          <el-radio-group v-model="editform.is_login_cert">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否真实实名:">
          <el-radio-group v-model="editform.is_real_cert">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否强制实名:">
          <el-radio-group v-model="editform.is_force_cert">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否强制更新:">
          <el-radio-group v-model="editform.is_force_update">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否正版iOS">
          <el-radio-group v-model="editform.genuine_ios">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否闪屏提示">
          <el-radio-group v-model="editform.is_flash_hint">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="调试模式:">
          <el-radio-group v-model="editform.is_debug">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否废弃包:">
          <el-radio-group v-model="editform.is_delete">
            <el-radio :label="1">废弃</el-radio>
            <el-radio :label="0">不废弃</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示游戏隐私协议">
          <el-radio-group v-model="editform.is_show_game_privacy">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示绑定手机">
          <el-radio-group v-model="editform.is_show_bind_phone">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否在SDK中显示扫码">
          <el-radio-group v-model="editform.is_scan_qrcode">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否强制绑定手机号:">
          <el-radio-group v-model="editform.is_force_bind_phone">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否禁止下载:">
          <el-radio-group v-model="editform.is_stop_download">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否通过公告更新:">
          <el-radio-group v-model="editform.is_update_by_notice">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="禁止拉人:">
          <el-radio-group v-model="editform.is_no_pull_old_user">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <div>
              <span>禁止换端</span>
              <el-tooltip content="在禁止拉人的前提,是否允许第一次注册在当前渠道包，然后在别的渠道登录，返回当前渠道包登录" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
              <span>:</span>
            </div>
          </template>
          <el-radio-group v-model="editform.is_no_change_login">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联运标签:">
          <el-input v-model="editform.pull_unionpay_tag"></el-input>
          <span class="ml1" style="font-size: 12px;"> * 开启禁止拉人的时候，一样的联运标签不限制</span>
        </el-form-item>
        <el-form-item label="需要进行强更的版本号:">
          <el-input v-model="editform.force_update_version"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏包" prop="game_package_id">
          <el-select v-model="editform.game_package_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in gamePackageList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道" prop="channel_id">
          <el-select v-model="editform.channel_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in channelSelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司主体:">
          <el-select v-model="editform.company_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in companySelectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <template v-if="editform.company_id === 7">
            <p style="color: red; margin-bottom: 0;"> * 注意：当前切的是三足乌的主体，会影响支付！！</p>
            <p style="color: red; margin: 0;">（2026-02-28 17点之前的包切支付，三足乌微信支付无法使用）</p>
          </template>
          <template v-else-if="editform.company_id === 8">
            <p style="color: red; margin-bottom: 0;"> * 注意：当前切的是三足乌-趣智联的主体，会影响支付！！</p>
            <p style="color: red; margin: 0;">（2026-06-29 12点之前的包切支付，三足乌-趣智联微信和支付宝支付无法使用）</p>
          </template>
        </el-form-item>
        <el-form-item label="对外主体:">
          <el-select v-model="editform.info_company_id" filterable clearable placeholder="请选择">
            <template v-if="companySelectList && companySelectList.length">
              <el-option v-for="item in [
                {
                  name: '无',
                  id: 0
                }
              ].concat(companySelectList)" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="是否H5游戏">
          <el-radio-group v-model="editform.is_h5_game">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="H5游戏链接">
          <el-input v-model="editform.h5_game_url"></el-input>
        </el-form-item>
        <el-form-item label="是否显示优惠券">
          <el-radio-group v-model="editform.is_show_coupon">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="隐私政策" prop="privacy">
          <wEditor ref="editorPrivacyE" :context="editform.privacy" />
        </el-form-item>
        <el-form-item label="用户协议" prop="protocol">
          <wEditor ref="editorProtocolE" :context="editform.protocol" />
        </el-form-item>
      </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editChannelPackageSubmit('editform')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 商务合作 -->
    <el-dialog title="商务合作" :visible.sync="dialogCooperateVisible" :close-on-click-modal="false" width="40%">
      <el-form :model="cooperateForm" label-width="156px" ref="cooperateForm">
        <el-form-item label="是否禁止登陆:">
          <el-radio-group v-model="cooperateForm.is_login_suspended">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否禁止注册:">
          <el-radio-group v-model="cooperateForm.is_register_suspended">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否禁止支付:">
          <el-radio-group v-model="cooperateForm.is_pay_suspended">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否切登陆:">
          <el-radio-group v-model="cooperateForm.is_switch_login">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否切支付:">
          <el-radio-group v-model="cooperateForm.is_switch_pay">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否禁止国内登录:">
          <el-radio-group v-model="cooperateForm.is_domestic_login_suspended">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="海外是否切支付:">
          <el-radio-group v-model="cooperateForm.is_switch_pay_oversea">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否禁止下载:">
          <el-radio-group v-model="cooperateForm.is_stop_download">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="禁止登陆版本:">
          <el-input-number v-model="cooperateForm.login_suspend_version"></el-input-number>
        </el-form-item>
        <el-form-item label="切支付最低金额">
          <el-input-number v-model="cooperateForm.swith_pay_amount" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="新设备X天内不切支付">
          <el-input-number v-model="cooperateForm.switch_pay_day"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCooperateVisible = false">取 消</el-button>
        <el-button type="primary" @click="cooperateFormSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { throttle } from "@/assets/js/public.js";
import { urlSplicing } from "@/assets/js/public.js";
import wEditor from '@/component/wEditor'
import _ from "lodash";

export default {
  name: "channelPackage",
  components: {
    wEditor
  },
  data() {
    return {
      cooperateForm: {
        is_login_suspended: 0,
        is_register_suspended: 0,
        is_pay_suspended: 0,
        is_switch_login: 0,
        is_switch_pay: 0,
        swith_pay_amount: 0,
        switch_pay_day: 0,
        is_domestic_login_suspended: 0,
        is_switch_pay_oversea: 0,
        is_stop_download: 0,
        login_suspend_version: 0,
      },
      dialogCooperateVisible: false,
      loadingData: false,
      searchValue: {
        id: "",
        name: "",
        channel_id: "",
        game_package_id: "",
        company_id: "",
      },
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamePackageList: [],
      channelSelectList: [],
      companySelectList: [],
      channelSelectAllList: [],
      addDialogFormVisible: false,
      editDialogFormVisible: false,
      addform: {
        id: "",
        name: "",
        channel_id: "",
        game_package_id: "",
        company_id: "",
        media_setting: "",
        union_setting: "",
        is_notice: "",
        is_login_cert: "",
        is_real_cert: "",
        is_force_cert: "",
        is_force_update: "",
        genuine_ios: "",
        verify_version: "",
        is_debug: "",
      },
      editform: {
        id: "",
        name: "",
        media_setting: "",
        union_setting: "",
        is_notice: "",
        is_login_cert: "",
        is_real_cert: "",
        is_force_cert: "",
        is_force_update: "",
        genuine_ios: "",
        verify_version: "",
        force_update_version: "",
        pull_unionpay_tag: "",
        is_debug: "",
        is_delete: 0,
        channel_id: "",
        game_package_id: "",
        is_flash_hint: "",
        is_show_game_privacy: "",
        is_show_bind_phone: "",
        is_scan_qrcode: "",
        is_force_bind_phone: "",
        is_stop_download: "",
        is_update_by_notice: "",
        is_no_pull_old_user: "",
        is_no_change_login: "",
        is_h5_game: "",
        h5_game_url: "",
        info_company_id: 0,
        is_show_coupon: "",
        company_id: '',
      },
      version: "",
      // 批量修改渠道包名
      dialogNameVisible: false,
      namePackageList: [],
      loadingNameData: false,
      nameSearchValue: {
        id: "",
        name: "",
        channel_id: "",
        game_package_id: "",
        company_id: "",
      },
      nameText: "",
      multipleSelection: [],
      currentNameSelection: [],
      selectedVerifyVersionPackages: [],
      batchVerifyVersionLoading: false,
    };
  },
  computed: {
    ...mapState(["host"]),
    isMultipleName() {
      const list = this.addform?.name?.split('\n')
      return list && list.length > 1
    },
    addRules() {
      const result = {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        game_package_id: [
          { required: true, message: "请选择所属游戏包", trigger: "change" },
        ],
        company_id: [
          { required: true, message: "请选择公司主体", trigger: "change" },
        ],
      }
      if (!this.isMultipleName) {
        result['channel_id'] = [
          { required: true, message: "请选择所属渠道", trigger: "change" },
        ]
      }
      if (this.addform.name.includes('主播') || this.addform.name.includes('信息流')) {
        result['media_setting'] = [
          { required: true, message: "请输入媒体配置", trigger: "blur" },
        ]
      } else {
        result['media_setting'] = [
          { required: false },
        ]
      }
      return result
    },
    rules() {
      const result = {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        channel_id: [
          { required: true, message: "请选择所属渠道", trigger: "change" },
        ],
        game_package_id: [
          { required: true, message: "请选择所属游戏包", trigger: "change" },
        ],
        company_id: [
          { required: true, message: "请选择公司主体", trigger: "change" },
        ],
      }
      if (this.editform.name.includes('主播') || this.editform.name.includes('信息流')) {
        result['media_setting'] = [
          { required: true, message: "请输入媒体配置", trigger: "blur" },
        ]
      } else {
        result['media_setting'] = [
          { required: false },
        ]
      }
      return result
    }
  },
  created() {
    this.getGamePackageSelectList();
    this.getchannelSelectList();
    this.getcompanySelectList();
    this.getChannelPackageList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["tableData"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    clearVerifyVersionSelection() {
      this.selectedVerifyVersionPackages = [];
      if (this.$refs.tableData) {
        this.$refs.tableData.clearSelection();
      }
    },
    handleVerifyVersionSelectionChange(selection) {
      this.selectedVerifyVersionPackages = selection;
    },
    openBatchVerifyVersionPrompt() {
      const count = this.selectedVerifyVersionPackages.length;
      if (!count) {
        this.$message.warning("请先选择需要修改的渠道包");
        return;
      }

      this.$prompt(`已选择${count}个渠道包，请输入新的提审版本号`, "批量修改提审版本号", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "可留空，留空将清空提审版本号",
      })
        .then(({ value }) => {
          this.batchUpdateVerifyVersions(String(value || "").trim());
        })
        .catch(() => {});
    },
    batchUpdateVerifyVersions(verifyVersion) {
      const ids = this.selectedVerifyVersionPackages
        .map((item) => item.id)
        .join(",");
      if (!ids) return;

      this.batchVerifyVersionLoading = true;
      fetch({
        url: "/admin/game_channel_packages/update_verify_versions",
        method: "POST",
        data: {
          ids,
          verify_version: verifyVersion,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.clearVerifyVersionSelection();
            this.$message.success("批量修改提审版本号成功");
            this.getChannelPackageList(false);
          } else {
            this.$message.error(res.data.message || "批量修改提审版本号失败");
          }
        })
        .finally(() => {
          this.batchVerifyVersionLoading = false;
        });
    },
    resetChannelPackageDialogScroll(refName) {
      this.$nextTick(() => {
        const dialogBody = this.$refs[refName];
        if (dialogBody && typeof dialogBody.scrollTo === "function") {
          dialogBody.scrollTo({ top: 0, left: 0, behavior: "auto" });
          return;
        }
        if (dialogBody) {
          dialogBody.scrollTop = 0;
          dialogBody.scrollLeft = 0;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getChannelPackageList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getChannelPackageList(false);
    },

    // 复制下载链接
    handleCopy(index, row, key = 'download_link') {
      this.copyData = row[key]
      this.copy(this.copyData);
    },
    // 复制方法
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },

    // 导出
    exportChannelPackage() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/game_channel_packages/list", params);
    },
    // 批量打包处理
    // batchPack() {
    //   let select_ids = [];
    //   this.$refs.tableData.selection.forEach(function (e, i) {
    //     select_ids.push(e.id);
    //   });
    //   if (select_ids.length == 0) {
    //     this.$message({
    //       message: "请选择要打包的数据",
    //       type: "error",
    //     });
    //     return false;
    //   } else {
    //     this.batchClick(select_ids.toString());
    //   }
    // },
    //批量打包提交
    // batchClick(val) {
    //   fetch({
    //     url: "/admin/game_channel_packages/batch_pack",
    //     method: "POST",
    //     data: {
    //       game_channel_package_ids: val,
    //     },
    //   }).then((res) => {
    //     if (res.data.status === 1) {
    //       this.$message({
    //         type: "success",
    //         message: "任务投递成功！正在打包~",
    //       });
    //       this.getChannelPackageList();
    //     } else {
    //       this.$message.error(res.data.message);
    //     }
    //   });
    // },

    // 获取游戏包选择列表数据
    getGamePackageSelectList(row) {
      fetch({
        url: "/admin/game_packages/select",
        method: "GET",
      }).then((res) => {
        this.gamePackageList = res.data.data;
      })
    },
    // 获取渠道选择列表数据
    getchannelSelectList(row) {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },

    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamePackageList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
    },

    // 获取公司选择列表数据
    getcompanySelectList(row) {
      fetch({
        url: "/admin/companies/select",
        method: "GET",
      }).then((res) => {
        this.companySelectList = res.data.data;
      });
    },
    // 实现渠道包数据的搜索
    searchChannelPackageList() {
      this.clearVerifyVersionSelection();
      this.currentPage = 1;
      this.getChannelPackageList(true);
    },
    // 显示新增渠道包对话框
    channelPackageAddDialog: throttle(function () {
      // 清空数据
      this.addform = {
        id: "",
        name: "",
        channel_id: "",
        game_package_id: "",
        company_id: "",
        media_setting: "",
        union_setting: "",
        is_notice: "0",
        is_force_cert: "0",
        is_login_cert: "0",
        is_real_cert: "0",
        is_force_update: "0",
        genuine_ios: "0",
        is_debug: "0",
      };
      this.addDialogFormVisible = true;
    }, 1000),

    // 实现新增渠道包
    addChannelPackageSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const nameList = this.addform.name.split('\n')
          if (nameList && nameList?.length > 1) {
            this.$confirm(`是否批量生成${nameList.length}个渠道?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.addChannelPackage(nameList)
            })
          } else {
            this.addChannelPackage()
          }
        }
      });
    },
    addChannelPackage(nameList) {
      const data = {
        ...this.addform
      }
      const privacy = this.$refs.editorPrivacy.html
      const protocol = this.$refs.editorProtocol.html
      if (privacy && privacy !== "<p><br></p>") {
        data.privacy = privacy
        this.$refs.editorPrivacy.html = ''
      }
      if (protocol && protocol !== "<p><br></p>") {
        data.protocol = protocol
        this.$refs.editorProtocol.html = ''
      }
      if (nameList && nameList?.length) data['name'] = nameList.toString()
      fetch({
        url: "/admin/game_channel_packages/create",
        method: "POST",
        data,
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getChannelPackageList();
          this.addDialogFormVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 商务合作
    channelPackageCooperateDialog(row) {
      this.cooperateForm = {
        id: row.id,
        is_login_suspended: row.is_login_suspended,
        is_register_suspended: row.is_register_suspended,
        is_pay_suspended: row.is_pay_suspended,
        is_switch_login: row.is_switch_login,
        is_switch_pay: row.is_switch_pay,
        swith_pay_amount: row.swith_pay_amount,
        switch_pay_day: row.switch_pay_day,
        is_domestic_login_suspended: row.is_domestic_login_suspended,
        is_switch_pay_oversea: row.is_switch_pay_oversea,
        is_stop_download: row.is_stop_download,
        login_suspend_version: row.login_suspend_version,
      }
      this.dialogCooperateVisible = true
    },
    // 编辑渠道包对话框--加载默认数据
    channelPackageEditDialog(row) {
      this.editform = _.cloneDeep(row)
      this.editform.is_delete = row.is_delete || 0;
      this.version = row.version;
      this.editDialogFormVisible = true;
    },
    // 商务合作提交
    cooperateFormSubmit() {
      fetch({
        url: "/admin/game_channel_packages/update_crucial_setting",
        method: "POST",
        data: {
          ...this.cooperateForm,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.getChannelPackageList();
          this.dialogCooperateVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 实现渠道包的编辑操作
    editChannelPackageSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.editform
          }
          const privacy = this.$refs.editorPrivacyE.html
          const protocol = this.$refs.editorProtocolE.html
          if (privacy) data.privacy = privacy !== "<p><br></p>" ? privacy : ''
          if (protocol) data.protocol = protocol !== "<p><br></p>" ? protocol : ''
          if (data.is_h5_game && !data.h5_game_url) {
            this.$message.error('请输入H5游戏链接')
            return
          }
          fetch({
            url: "/admin/game_channel_packages/update",
            method: "POST",
            data,
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.getChannelPackageList();
              this.editDialogFormVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },

    // 打包
    packaging(formName) {
      fetch({
        url: "/admin/game_channel_packages/pack",
        method: "POST",
        data: {
          game_channel_package_id: formName,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: "任务投递成功！正在打包~",
          });
          this.getChannelPackageList();
          this.editDialogFormVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 下载
    downloadFile(downloadUrl) {
      window.open(downloadUrl);
    },

    // 展示渠道包列表数据
    getChannelPackageList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/game_channel_packages/list",
        method: "GET",
        params: {
          ...searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    // 展示渠道包列表数据
    getNameChannelPackageList() {
      this.loadingNameData = true;
      fetch({
        url: "/admin/game_channel_packages/list",
        method: "GET",
        params: {
          ...this.nameSearchValue,
          page: 1,
          per_page: 1000,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.namePackageList = res.data.data.data;
            this.multipleSelection = []
            // 多选表格，清空用户的选择
            this.$refs.tableNameData.clearSelection();
          }
        })
        .finally(() => {
          this.loadingNameData = false;
        });
    },
    setNameChange() {
      if (!this.nameText) {
        this.$message.error('请填写渠道包名')
        return
      }
      if (!this.currentNameSelection?.length) {
        this.$message.error('请选择需要修改的渠道包')
        return
      }
      const nameList = this.nameText.split('\n')
      this.currentNameSelection = this.currentNameSelection.map((item, index) => {
        const new_name = nameList[index]
        return {
          ...item,
          new_name
        }
      })
    },
    handleNameSelectionChange(val) {
      const clearList = this.multipleSelection.length ? this.currentNameSelection.filter(({ id }) => !this.multipleSelection.find(item => item.id === id)) : this.currentNameSelection
      console.log(this.currentNameSelection, clearList, this.multipleSelection)
      this.multipleSelection = val
      this.currentNameSelection = clearList.concat(val.length ? val.filter(({ id }) => !clearList.find(item => item.id === id)) : val)
    },
    setNamePackageSelect() {
      // 参数names：格式{渠道id:"名字","渠道id":"名字"} 
      const names = {}
      let unnameList = []
      this.currentNameSelection.forEach(({ id, name, new_name }) => {
        if (new_name) {
          names[id] = new_name
        } else {
          unnameList.push(`(ID: ${id})${name}`)
        }
      })
      if (unnameList?.length) {
        this.$alert(unnameList.join(';'), '以下选中渠道包未修改', {
          confirmButtonText: '确定',
        })
        return
      }
      fetch({
        url: "/admin/game_channel_packages/update_names",
        method: "POST",
        data: {
          names: JSON.stringify(names)
        }
      }).then((res) => {
        if (res.data.status) {
          this.nameText = ''
          this.unnameList = []
          this.currentNameSelection = []
          this.$refs.tableNameData.clearSelection()
          this.$message.success('批量修改成功')
          this.dialogNameVisible = false
        } else {
          this.$message.error('批量修改成功:' + res.data.message)
        }
      })
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}

.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  .el-input-group {
    width: 370px;
  }
}

.channel-package-dialog {
  width: min(900px, calc(100vw - 32px)) !important;
  max-height: 90vh;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 12px 20px 0;
  }

  .channel-package-dialog__body {
    max-height: calc(90vh - 150px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
  }

  .el-dialog__footer {
    flex-shrink: 0;
    padding-top: 16px;
  }
}
</style>
